import { render, staticRenderFns } from "./TablePatients.vue?vue&type=template&id=796bbf54"
import script from "./TablePatients.vue?vue&type=script&lang=js"
export * from "./TablePatients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports